import { useMembersStore } from "@/features/members/services/members-store"

export async function createInvite(memberId: string, email: string, actor: string) {
  const member = useMembersStore.getState().getMemberById(memberId)
  if (!member) {
    throw new Error("Member not found.")
  }
  if (!member.email || member.email.toLowerCase() !== email.toLowerCase()) {
    throw new Error("Invite email does not match member email.")
  }
  return useMembersStore.getState().createInvite(memberId, actor)
}
